/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
// eslint-disable-next-line import/no-cycle
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid } from '@mui/material';
import { MdOutlineCheck } from 'react-icons/md';
import { Header } from '../../../../pricing-simulator/types/generic-table.model';

export default function getHeaderForOpportunityFlag(columnData: Header) {
    const subHeader: ColumnDef<{
        [key: string]: number | string | { [key: string]: string }[];
    }> = {
        id:
            columnData.parent.parent_field !== ''
                ? columnData.parent.parent_field
                : columnData.parent.order.toString(),
        // eslint-disable-next-line react/no-unescaped-entities
        header: (props) =>
            columnData.children.length > 1 ? (
                <div>
                    {' '}
                    {columnData.parent.alias} {getHeaderName(columnData)}
                </div>
            ) : null,
        cell: ({ row }) =>
        /**
         * If the opportunity is not applicable to child then don't show it
         */
        (
            <>
                <div style={{ width: '100%', textAlign: 'center' }}>{!row.original[columnData.parent.parent_field] &&
                    '-'}</div>
                {row.original[columnData.parent.parent_field] &&
                    <Grid container justifyContent='center' p={1}>
                        <Grid
                            item
                            container
                            justifyContent='center'
                            alignItems='center'
                            sx={{
                                height: '30px',
                                width: '30px',
                                borderRadius: '50%',
                                // backgroundColor: opportunity.color
                                backgroundColor: row.original[columnData.parent.parent_field] ? columnData.parent.fill_color : '#FFFFFF'
                            }}
                        >
                            <MdOutlineCheck fontSize='18px' color='white' />
                        </Grid>
                    </Grid>}
            </>
        )
        ,
        meta: {
            className: 'opportunity-highlight-column'
        }
    };
    return subHeader;
};